import * as Backbone from "backbone";
import _ from "lodash";

export function getter(modelOrObject, field) {
	const attr = (modelOrObject instanceof Backbone.Model) ? modelOrObject.attributes : modelOrObject;
	return _.get(attr, field);
}

export function setter(modelOrObject, field, val, options) {
	if (modelOrObject instanceof Backbone.Model) {
		const valueObj = _.set(_.cloneDeep(modelOrObject.attributes), field, val);
		modelOrObject.set(valueObj, options);
	} else {
		_.set(modelOrObject, field, val);
	}
}
